import { Children, cloneElement, useRef } from 'react'
import cx from 'classnames'

import { useDetectClickOutside, useModalState } from 'hooks'

type PopupProps = {
  handleClass?: string
  disabled?: boolean
  children?: any
}

const Popup = ({ handleClass, children, disabled }: PopupProps) => {
  const popupState = useModalState()
  const ref = useRef(null)

  useDetectClickOutside(ref, popupState.toggle, popupState.isActive)

  return (
    <div
      className={cx('Popup', {
        [`Popup--${handleClass}`]: handleClass,
      })}
      ref={ref}
    >
      <a
        className="Popup__a"
        onClick={disabled ? () => {} : popupState.toggle}
        aria-disabled={disabled}
      />

      <div
        className={cx('Popup__panel', {
          'Popup__panel--active': popupState.isActive,
        })}
      >
        {/* Clone to apply additional props. */}
        {Children.map(children, (child) =>
          cloneElement(child, {
            onTogglePopup: popupState.toggle,
          })
        )}
      </div>
    </div>
  )
}

export default Popup
